import { render, staticRenderFns } from "./TravelInsuranceVerification.vue?vue&type=template&id=4f505169"
import script from "./TravelInsuranceVerification.vue?vue&type=script&lang=ts"
export * from "./TravelInsuranceVerification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports